import { Button, FormContext, FormItem, Icon, Table } from '@digital/ui';
import React, { useContext, useEffect, useState } from 'react';
import Upload, { UploadProps } from 'antd/lib/upload';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import { Visibility } from '../Visibility';

interface IProps {
    fileName?: string;
    accept?: string;
    label?: string;
    url?: string;
    disabled?: boolean;
    type?: string;
    className?: string;
    idDoComponente: string;
    name?: string;
    showData?: boolean;

    visible?: boolean;
    showUpload?: boolean;
    showTableData?: boolean;
}

export const UploadMultipleTable = (
    { accept,
        label,
        type,
        className,
        idDoComponente,
        name,
        showData,
        visible = true,
        showUpload = true,
        showTableData = true,
        disabled = false
    }: IProps
) => {
    const buttonLabel = label ? label : 'Adicionar arquivo';
    const [listFileC, setListFileC] = useState([]);
    const { formProps } = useContext(FormContext);
    const formName = name ? name : 'files';

    const remove = (record) => {
        var list = listFileC.filter(c => c.uid !== record.uid);
        setListFileC(list);
    };

    const updateFile = (list) => {
        setListFileC(list.fileList);
    };

    useEffect(() => {
        let files = [];
        listFileC.map(c => files.push(c.originFileObj));
        formProps && formProps.setFieldValue(formName, files);
    }, [listFileC]);


    const uploadProps: UploadProps = {
        action: '',
        multiple: true,
        type: 'select',
        accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
        onRemove: _ => {
            formProps && formProps.setFieldValue(formName, null);
        },
        beforeUpload: file => {
            return false;
        },
        headers: {
            authorization: 'authorization-text',
        },
    };


    const columns = () => {
        const columns = [];

        columns.push({
            title: 'Nome',
            dataIndex: 'name'
        });

        if (showData) {
            columns.push({
                title: 'Inclusão',
                width: '20%',
                render: (text, record) => moment().format(dateTimeFormat)
            });
        }

        columns.push({
            title: 'Ações',
            width: '10%',
            render: (text, record) => <Button onClick={() => remove(record)} ><Icon name='commons-trash' /></Button>
        });
        return columns;
    };

    return (
        <Visibility visible={visible}>

            <FormItem name={formName} span={12}>
                <Visibility visible={showUpload}>
                    <Upload
                        id={idDoComponente}
                        fileList={listFileC}
                        onChange={e => updateFile(e)}
                        showUploadList={false}
                        className={className}
                        disabled={disabled}
                        name={formName}
                        {...uploadProps}>
                        <Button
                            id='mrn-button-upload-inserirAnexo'
                            type={type ? type : 'link'}
                            icon="ui-upload">
                            {buttonLabel}
                        </Button>
                    </Upload>
                </Visibility>

                <Visibility visible={showTableData}>
                    {formProps && (
                        <Table
                            className='upload-multiple-table'
                            pagination={false}
                            dataSource={listFileC}
                            columns={columns()}
                        />
                    )}
                </Visibility>
            </FormItem>
        </Visibility>
    );
};